import { Drawer, Button, Group } from '@mantine/core';
import SignatureCanvas from 'react-signature-canvas';
import { useRef, useState } from 'react';
import { useClientTranslation } from 'hooks/useClientTranslation';
import { SignatureCanvasWrapper } from './SignatureCanvasWrapper';
import Flex from 'components/Flex';

interface SignatureModalProps {
  opened: boolean;
  onClose: () => void;
  onSubmit: (signatureBase64: string) => void;
}

export const SignatureModal = ({ opened, onClose, onSubmit }: SignatureModalProps) => {
  const sigPad = useRef<SignatureCanvas>(null);
  const [isEmpty, setIsEmpty] = useState(true);
  const { t } = useClientTranslation();

  const handleClear = () => {
    sigPad.current?.clear();
    setIsEmpty(true);
  };

  const handleSubmit = () => {
    if (sigPad.current && !sigPad.current.isEmpty()) {
      const dataUrl = sigPad.current.toDataURL('image/png');
      onSubmit(dataUrl);
      onClose();
    }
  };

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="bottom"
      size="xl"
      withCloseButton={false}
      overlayColor="#12191F"
      overlayOpacity={0.35}
      closeOnClickOutside={false}
      styles={(_theme) => ({
        drawer: {
          borderTopLeftRadius: '12px',
          borderTopRightRadius: '12px',
          padding: '24px 24px 40px',
        },
      })}
    >
      <Flex
        align="center"
        style={{
          width: 320,
          margin: '0 auto',
          marginTop: 10,
        }}
        gap={16}
      >
        <div style={{ fontWeight: 700, fontSize: 18 }}>{t('conte.signature.header')}</div>
        <div>{t('conte.signature.instruction')}</div>
        <div style={{ marginBottom: 16 }}>
          <div style={{ border: '1px solid #ccc', borderRadius: 4, marginTop: 10 }}>
            <SignatureCanvasWrapper
              ref={sigPad}
              onEnd={() => setIsEmpty(false)}
              canvasProps={{
                width: 320,
                height: 200,
                className: 'signature-canvas',
                style: { width: 320, height: 200 }
              }}
            />
          </div>
        </div>
        <Group position="apart" style={{ width: '100%' }}>
          <Button
            variant="outline"
            onClick={handleClear}
            style={{ flex: 1 }}
          >
            {t('global.clear')}
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={isEmpty}
            style={{ flex: 1 }}
          >
            {t('global.submit')}
          </Button>
        </Group>
      </Flex>
    </Drawer>
  );
};